import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
/**
 * `Service` Building Connected Service
 */
var BuildingConnected = /*#__PURE__*/function (_Base) {
  /**
   * Create buildingConnected service instance
   *
   * @param sdk - the SDK instance
   */
  function BuildingConnected(sdk) {
    _classCallCheck(this, BuildingConnected);
    return _callSuper(this, BuildingConnected, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(BuildingConnected, _Base);
  return _createClass(BuildingConnected, [{
    key: "getLinkedObjects",
    value: (
    /**
     * Returns BC objects linked to an ACC project. This is an internal endpoint that is restricted to the BC and ACC clients as it is not scoped to a particular BC company. This supports 3LO requests from any user.
     * https://platform.stoplight.autodesk.com/docs/buildingconnected-api/branches/internal_linked_objects/buildingconnected-internal.yaml/paths/~1linked-objects/get
     *
     *  @param params -  width the shape of cursorState, limit, filter
     * @param config -  Configurable object for overwrite request parameters.
     * @returns results and pagination
     */
    function () {
      var _getLinkedObjects = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, config) {
        var query, url, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = QS.stringify(params, {
                addQueryPrefix: true,
                encode: false
              });
              url = "/linked-objects".concat(query);
              _context.next = 4;
              return this.HttpService.bcInternal.get(url, config);
            case 4:
              res = _context.sent;
              return _context.abrupt("return", res.data);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getLinkedObjects(_x, _x2) {
        return _getLinkedObjects.apply(this, arguments);
      }
      return getLinkedObjects;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'BuildingConnected';
    }
  }]);
}(Base);
export default BuildingConnected;